import {useEffect, useRef} from 'react'
import { DrawerComponent, MenuComponent, ScrollTopComponent, StickyComponent, ToggleComponent } from '../../assets/components'


import {useLayout} from './core'

/**
 * Inicializa los plugins de KTMetric (Toggle, ScrollTop, Drawer, Sticky, Menu)
 * una unica vez al montar la aplicacion. No renderiza nada (retorna <></>).
 */
export function MasterInit() {
  const {config} = useLayout()
  const isFirstRun = useRef(true)
  const pluginsInitialization = () => {
    isFirstRun.current = false
    setTimeout(() => {
      ToggleComponent.bootstrap()
      ScrollTopComponent.bootstrap()
      DrawerComponent.bootstrap()
      StickyComponent.bootstrap()
      MenuComponent.bootstrap()
    }, 500)
  }

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      pluginsInitialization()
    }
  }, [config])

  return <></>
}
